// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"4230606d","79":"f8f929bd","109":"ad204922","185":"e8565ce2","285":"7c567a04","817":"277a2e7e","974":"411d6fdf"}[chunkId] + ".js";
};